import { ProductScreenshot } from 'components/ProductScreenshot';
import selectReplayControlDark from "../../../../contents/images/tutorials/limit-session-recordings/select-replay-control-flag-dark-mode.png";
import selectReplayControlLight from "../../../../contents/images/tutorials/limit-session-recordings/select-replay-control-flag-light-mode.png";
import flagDark from "../../../../contents/images/tutorials/limit-session-recordings/feature-flag-to-control-sessions-dark-mode.png";
import flagLight from "../../../../contents/images/tutorials/limit-session-recordings/feature-flag-to-control-sessions-light-mode.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  selectReplayControlDark,
  selectReplayControlLight,
  flagDark,
  flagLight,
  React
};